import { getConfigURL } from "../utils/constants";
import axios from "axios";

const getConfig = async () => {
    try {
        const response = await axios.get(getConfigURL);
        return response.data;
    } catch (error) {
        return false
    }
}

export { getConfig };